import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { HiDocumentText } from "react-icons/hi2";
import { RiHome3Fill } from "react-icons/ri";
import { FaExchangeAlt, FaUsers } from "react-icons/fa";
import { FaSackDollar } from "react-icons/fa6";
import { HiOutlineLink } from "react-icons/hi";
import { FaLink } from "react-icons/fa";

import { MdBalance, MdElectricBolt, MdWallet } from "react-icons/md";
import { FaRegBell } from "react-icons/fa";
import { IoSettingsOutline, IoLanguage } from "react-icons/io5";
import { HiChevronDown } from "react-icons/hi2";
import { IoSettings } from "react-icons/io5";
import { GiWallet } from "react-icons/gi";
import { TbApi } from "react-icons/tb";
import { IoIosArrowUp } from "react-icons/io";
import NewTransaction from "../../components/NewTransaction";
import Dashboard from "../NewDashboard/Dashboard";
import Balance from "../NewDashboard/Balance";
import SettingsPage from "../SettingsPage";
import TwoFactorAuthPage from "../TwoFactorAuthPage";
import RoleManagementPage from "../RoleManagementPage";
import WalletServices from "../WalletServices/WalletServices";
import { API_BASE_URL } from "../../utils/apiConfig";
import { IoMdAdd } from "react-icons/io";
import RecentDashboard from "../Homedashboard/RecentDashboard";
import { FaPersonMilitaryToPerson } from "react-icons/fa6";

import BalanceDashboard from "../Homedashboard/BalanceDashboard";
import NewPaymentLink from "../WalletServices/NewPaymentLink";
import { FaWallet } from "react-icons/fa6";
import { IoLogoIonic } from "react-icons/io5";
import { MdArrowOutward } from "react-icons/md";
import { HiCodeBracketSquare } from "react-icons/hi2";
import WidthdrawalNew from "../WalletServices/WidthdrawalNew";
import WalletuserId from "../WalletServices/WalletuserId";
import AuthGuard from "../../components/AuthGuard";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/formatNumber";
import usePermissions from "../../hooks/usePermissions";
import TwoFAEnforcementModal from "../../components/TwoFAEnforcementModal";
// import ReferralPage from "../ReferralPage";

const NewDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage } = useLanguage();
  const { canAccessPage } = usePermissions();

  // Helper function to translate period values
  const translatePeriod = (period) => {
    const periodMap = {
      Daily: t("dashboard.daily"),
      Weekly: t("dashboard.weekly"),
      Monthly: t("dashboard.monthly"),
      Custom: t("dashboard.custom") || "Custom",
    };
    return periodMap[period] || period;
  };

  const [activeTab, setActiveTab] = useState("PAYMENTS");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectFeaturesOpen, setSelectFeaturesOpen] = useState(false);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [activeViewOption, setActiveViewOption] = useState("Daily");
  // Default to current date for period filter (auto-select today's date)
  const todayStr = new Date().toISOString().split("T")[0];
  const [activePeriod, setActivePeriod] = useState("Daily");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);
  const [fromDate, setFromDate] = useState(todayStr);
  const [toDate, setToDate] = useState(todayStr);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [notificationsError, setNotificationsError] = useState(null);
  const [notifPage, setNotifPage] = useState(1);
  const [notificationsPagination, setNotificationsPagination] = useState({
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  });
  const [profileData, setProfileData] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileError, setProfileError] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  // 2FA enforcement state
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [twoFAEnabled, setTwoFAEnabled] = useState(null); // null = loading, true = enabled, false = disabled

  // Gross Volume Chart state
  const [grossVolumeData, setGrossVolumeData] = useState([]);
  const [grossVolumeLoading, setGrossVolumeLoading] = useState(false);
  const [grossVolumeError, setGrossVolumeError] = useState(null);
  const [grossVolumeTotal, setGrossVolumeTotal] = useState(0);
  const [grossVolumePeriod, setGrossVolumePeriod] = useState(null);

  // Dashboard Stats state
  const [dashboardStats, setDashboardStats] = useState(null);

  const [statsLoading, setStatsLoading] = useState(false);
  const [statsError, setStatsError] = useState(null);

  // Fetch profile data
  const fetchProfile = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const userRole = localStorage.getItem("userRole");

      if (!userId) {
        setProfileError("User not logged in");
        return;
      }

      setProfileLoading(true);
      setProfileError("");

      // Use merchant endpoint to get profile data
      const response = await fetch(`${API_BASE_URL}/merchant/${userId}`, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        console.log("response.status", response.status);

        if (response.status === 401) {
          navigate("/");
        }
        // throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setProfileData(data.data);
      } else {
        console.log("Sdagasdgsad", data);

        throw new Error(data.message || "Failed to fetch profile data");
      }
    } catch (err) {
      console.error("5646465", err);
      if (err === 401) {
        <Navigate to="/" replace />;
      }
      setProfileError(err.message || "Failed to fetch profile data");
    } finally {
      setProfileLoading(false);
    }
  };

  // Refresh profile data
  const refreshProfile = () => {
    fetchProfile();
  };

  // Fetch Dashboard Stats
  const fetchDashboardStats = async (
    customFromDate = null,
    customToDate = null,
  ) => {
    try {
      setStatsLoading(true);
      setStatsError(null);

      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");

      // Build URL with date filters
      let url = `${API_BASE_URL}/dashboard/stats`;
      const params = new URLSearchParams();

      // If custom dates are provided, use them; otherwise use activePeriod
      if (customFromDate && customToDate) {
        params.append("fromdate", customFromDate);
        params.append("todate", customToDate);
      } else {
        // Map activePeriod to API dateFilter parameter (no 'Yearly' — custom handled separately)
        const dateFilterMap = {
          Daily: "today",
          Weekly: "week",
          Monthly: "month",
        };
        const dateFilter = dateFilterMap[activePeriod] || "today";
        params.append("dateFilter", dateFilter);
      }

      url += `?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setDashboardStats(data.data || null);
      } else {
        throw new Error(data.message || "Failed to fetch dashboard stats");
      }
    } catch (err) {
      console.error("Error fetching dashboard stats:", err);
      setStatsError(err.message || "Failed to fetch dashboard stats");
      setDashboardStats(null);
    } finally {
      setStatsLoading(false);
    }
  };

  // Fetch Gross Volume data
  const fetchGrossVolumeData = async () => {
    try {
      setGrossVolumeLoading(true);
      setGrossVolumeError(null);

      // Map activeViewOption to API dateFilter parameter
      const dateFilterMap = {
        Daily: "daily",
        Weekly: "weekly",
        Monthly: "monthly",
      };

      const dateFilter = dateFilterMap[activeViewOption] || "daily";

      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/dashboard/deposit-gross-volume?dateFilter=${dateFilter}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        // Map the API response to our state
        // API returns: data.graphData (array with count, amount, level)
        // API returns: data.summary.totalGrossVolume
        // API returns: data.summary.period (startDate, endDate)
        setGrossVolumeData(data.data.graphData || []);
        setGrossVolumeTotal(data.data.summary?.totalGrossVolume || 0);
        setGrossVolumePeriod(data.data.summary?.period || null);
      } else {
        throw new Error(data.message || "Failed to fetch gross volume data");
      }
    } catch (err) {
      console.error("Error fetching gross volume data:", err);
      setGrossVolumeError(err.message || "Failed to fetch gross volume data");
      // Set empty data on error
      setGrossVolumeData([]);
      setGrossVolumeTotal(0);
      setGrossVolumePeriod(null);
    } finally {
      setGrossVolumeLoading(false);
    }
  };

  // Logout function
  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE_URL}/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
      // localStorage.clear();
      // sessionStorage.clear();
      setProfileData(null); // Clear profile data
      setShowLogoutModal(false);
      navigate("/#/login");
    } catch (err) {
      alert("Logout failed!");
    }
  };

  // Check 2FA status
  const check2FAStatus = async () => {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/auth/2fa-status`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      const data = await response.json();
      if (response.ok && data.data) {
        const isEnabled =
          data.data.enabled2FA === "true" || data.data.enabled2FA === true;
        const isVerified =
          data.data.verified2FA === "true" || data.data.verified2FA === true;

        // User must have 2FA both enabled AND verified
        const has2FA = isEnabled && isVerified;
        setTwoFAEnabled(has2FA);

        // Show modal if 2FA is not properly set up and we're not on the 2FA page
        if (!has2FA && !location.pathname.includes("/security/2fa")) {
          setShow2FAModal(true);
        }
      } else {
        // If we can't check status, assume 2FA is not enabled
        setTwoFAEnabled(false);
        if (!location.pathname.includes("/security/2fa")) {
          setShow2FAModal(true);
        }
      }
    } catch (err) {
      console.error("Error checking 2FA status:", err);
      // On error, assume 2FA is not enabled to be safe
      setTwoFAEnabled(false);
      if (!location.pathname.includes("/security/2fa")) {
        setShow2FAModal(true);
      }
    }
  };

  // Fetch notifications function
  const fetchNotifications = async (page = 1) => {
    setNotificationsLoading(true);
    setNotificationsError(null);

    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const res = await fetch(
        `${API_BASE_URL}/notifications?page=${page}&limit=10`,
        {
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        },
      );

      const data = await res.json();

      if (data.success) {
        setNotifications(data.data);
        setNotifPage(page);
        setNotificationsPagination({
          total: data.pagination.total,
          page: data.pagination.page,
          limit: data.pagination.limit,
          totalPages: data.pagination.totalPages,
        });
      } else {
        setNotificationsError("Failed to load notifications");
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
      setNotificationsError("Failed to load notifications");
    } finally {
      setNotificationsLoading(false);
    }
  };

  // Mark all notifications as read
  const markAllAsRead = async () => {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/notifications/read-all`, {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      const data = await res.json();

      if (data.success) {
        // Refresh notifications to update read status
        fetchNotifications(notificationsPagination.page);
      }
    } catch (err) {
      console.error("Error marking notifications as read:", err);
    }
  };

  const handleFeatureToggle = (featureId) => {
    setSelectedFeatures((prev) =>
      prev.includes(featureId)
        ? prev.filter((id) => id !== featureId)
        : [...prev, featureId],
    );
  };

  // Scroll detection for header blur effect
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close sidebar on desktop screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch profile and notifications when component mounts
  useEffect(() => {
    fetchProfile();
    fetchNotifications(1);
    // fetchDashboardStats();
    // fetchGrossVolumeData();
    check2FAStatus(); // Check 2FA status on mount
  }, []);

  // Check 2FA status when navigating between pages
  useEffect(() => {
    if (location.pathname.includes("/security/2fa")) {
      // User is on 2FA page, hide the modal
      setShow2FAModal(false);
    } else if (twoFAEnabled === false) {
      // User navigated away from 2FA page but still doesn't have 2FA enabled
      setShow2FAModal(true);
    }
  }, [location.pathname, twoFAEnabled]);

  // Fetch Dashboard Stats when activePeriod changes
  useEffect(() => {
    if (activePeriod === "Custom") {
      // Open date picker for custom range and skip automatic fetch
      setShowDatePicker(true);
      return;
    }
    fetchDashboardStats();
  }, [activePeriod]);

  // Fetch Gross Volume data when activeViewOption changes
  useEffect(() => {
    fetchGrossVolumeData();
  }, [activeViewOption]);

  // Fetch notifications when popover is opened
  useEffect(() => {
    if (showNotifications && notifications.length === 0) {
      fetchNotifications(1);
    }
  }, [showNotifications]);

  // Prevent background scroll when notifications popover is open
  useEffect(() => {
    if (showNotifications) {
      // Save current scroll position
      const scrollY = window.scrollY;

      // Prevent scrolling on body
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      // Re-enable scrolling
      const scrollY = document.body.style.top;
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";

      // Restore scroll position
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    }

    // Cleanup function
    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [showNotifications]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectFeaturesOpen && !event.target.closest(".relative")) {
        setSelectFeaturesOpen(false);
      }
      if (showPeriodDropdown && !event.target.closest(".period-dropdown")) {
        setShowPeriodDropdown(false);
      }
      if (showDatePicker && !event.target.closest(".date-picker")) {
        setShowDatePicker(false);
      }
      if (
        showNotifications &&
        !event.target.closest(".notifications-popover")
      ) {
        setShowNotifications(false);
      }
      if (showLanguageDropdown && !event.target.closest(".language-dropdown")) {
        setShowLanguageDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [
    selectFeaturesOpen,
    showPeriodDropdown,
    showDatePicker,
    showNotifications,
    showLanguageDropdown,
  ]);

  // State for wallet dropdown
  const [walletsDropdownOpen, setWalletsDropdownOpen] = useState(false);

  // Get user role from localStorage
  const userRole = localStorage.getItem("userRole");
  const isSubUser = localStorage.getItem("isSubUser");
  const isMainUser = !isSubUser || isSubUser === "false";

  // Filter sidebar items based on user role
  const allSidebarItems = [
    {
      name: t("common.home"),
      icon: "home",
      path: "/New-Dashboard",
      active: location.pathname === "/New-Dashboard",
    },
    {
      name: t("common.transactions"),
      icon: "transactions",
      path: "/New-Dashboard/transactions",
      active: location.pathname === "/New-Dashboard/transactions",
    },
    {
      name: t("common.balances"),
      icon: "balance",
      path: "/New-Dashboard/balances",
      active: location.pathname === "/New-Dashboard/balances",
    },
  ];

  // Filter sidebar items based on user permissions
  // Home is always accessible; other items filtered by permission
  const sidebarItems = allSidebarItems.filter(
    (item) => item.path === "/New-Dashboard" || canAccessPage(item.path)
  );

  // Filter services items based on user role
  const allServicesItems = [
    {
      name: t("sidebar.paymentLinks"),
      icon: "payments",
      path: "/New-Dashboard/payments",
      active: location.pathname === "/New-Dashboard/payments",
    },
    {
      name: t("sidebar.wallets"),
      icon: "wallet",
      path: "/New-Dashboard/wallet",
      active:
        location.pathname === "/New-Dashboard/wallet" ||
        location.pathname === "/New-Dashboard/wallet-settings",
      hasDropdown: true,
      dropdownItems: [
        { name: t("sidebar.overview"), path: "/New-Dashboard/wallet" },
        // { name: "Settings", path: "/New-Dashboard/settings" }
      ],
    },
    /*
    {
      name: t("sidebar.tokenization"),
      icon: "docs",
      path: "/New-Dashboard/docs",
      active: location.pathname === "/New-Dashboard/docs"
    },
    */
    {
      name: t("sidebar.withdrawals"),
      icon: "withdrawals",
      path: "/New-Dashboard/widthdrawal",
      active: location.pathname === "/New-Dashboard/widthdrawal",
    },
    {
      name: t("sidebar.roleManagement"),
      icon: "role",
      path: "/New-Dashboard/role-management",
      active: location.pathname === "/New-Dashboard/role-management",
    },
    {
      name: "Referrals",
      icon: "referral",
      path: "/New-Dashboard/referrals",
      active: location.pathname === "/New-Dashboard/referrals",
    },
  ];

  // Filter services items based on user permissions
  // Referrals shown ONLY for main merchant users (not permission-based)
  const servicesItems = allServicesItems.filter((item) => {
    // Referrals: only for main merchants (not a permission-gated feature)
    if (item.icon === "referral") {
      return userRole === "merchant" && isMainUser;
    }
    // All other items filtered by permission
    return canAccessPage(item.path);
  });

  const allDevelopersItems = [
    {
      name: t("sidebar.developers"),
      icon: "API",
      path: "/New-Dashboard/api-docs",
      active: location.pathname === "/New-Dashboard/api-docs",
    },
  ];

  // Filter developers items based on user permissions
  const developersItems = allDevelopersItems.filter((item) =>
    canAccessPage(item.path)
  );

  const renderIcon = (iconType, isActive) => {
    const iconClass = `w-5 h-4 ${isActive ? "text-[#348BED]" : "text-gray-500"}`;

    // ✅ Keep same size and spacing for both states
    const iconWrapperClass = `
    flex items-center justify-center rounded-[6px] w-7 h-7
    ${isActive ? "bg-[#2962FF1A]" : ""}
  `;

    let IconComponent;

    switch (iconType) {
      case "home":
        IconComponent = RiHome3Fill;
        break;
      case "transactions":
        IconComponent = FaExchangeAlt;
        break;
      case "balance":
        IconComponent = FaSackDollar;
        break;
      case "wallet":
        IconComponent = FaWallet;
        break;
      case "users":
        IconComponent = FaUsers;
        break;
      case "settings":
        IconComponent = IoSettings;
        break;
      case "API":
        IconComponent = HiCodeBracketSquare;
        break;
      case "docs":
        IconComponent = IoLogoIonic;
        break;
      case "payments":
        IconComponent = HiOutlineLink;
        break;
      case "withdrawals":
        IconComponent = MdArrowOutward;
        break;
      case "role":
        IconComponent = FaPersonMilitaryToPerson;
        break;
      case "referral":
        IconComponent = FaLink;
        break;
      default:
        return null;
    }

    return (
      <div className={iconWrapperClass}>
        <IconComponent className={iconClass} />
      </div>
    );
  };

  const StatCard = ({
    title,
    value,
    subtitle,
    showDropdown = false,
    showView = false,
  }) => (
    <div className="bg-white rounded-[25px] p-6  ">
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium text-gray-600">{title}</h3>
          {showDropdown && (
            <span className="text-gray-400">
              <IoIosArrowDown />
            </span>
          )}
        </div>
        {showView && (
          <button
            onClick={() => navigate("/New-Dashboard/transactions")}
            className="text-[#348BED] text-sm font-medium hover:text-blue-800"
          >
            {t("common.view")}
          </button>
        )}
      </div>
      <div className="text-2xl font-medium text-gray-900 mb-1">
        {typeof value === "number" ? formatNumber(value) : value}
      </div>
      <div className="text-sm text-gray-500">
        {typeof subtitle === "string" || typeof subtitle === "number"
          ? subtitle
          : subtitle}
      </div>
    </div>
  );

  const ChartCard = ({
    title,
    children,
    showInfo = false,
    month = false,
    dateRange = null,
  }) => {
    // Calculate date range based on activeViewOption if dateRange is not provided
    const calculateDateRange = () => {
      // Local-safe parser for YYYY-MM-DD
      const parseYmdLocal = (value) => {
        if (!value || typeof value !== "string") return null;
        const m = value.match(/^\s*(\d{4})-(\d{2})-(\d{2})\s*$/);
        if (!m) {
          const d = new Date(value);
          return isNaN(d.getTime()) ? null : d;
        }
        const y = Number(m[1]);
        const mo = Number(m[2]);
        const da = Number(m[3]);
        const d = new Date(y, mo - 1, da);
        return isNaN(d.getTime()) ? null : d;
      };

      // If dateRange is provided from API, use it (timezone safe)
      if (dateRange && dateRange.start && dateRange.end) {
        const startDate = parseYmdLocal(dateRange.start);
        const endDate = parseYmdLocal(dateRange.end);

        if (startDate && endDate) {
          return { start: startDate, end: endDate };
        }
      }

      // Calculate based on activeViewOption
      const today = new Date();
      let startDate = new Date(today);
      let endDate = new Date(today);

      switch (activeViewOption) {
        case "Daily":
          // Today only
          startDate = new Date(today);
          endDate = new Date(today);
          break;
        case "Weekly":
          // Past 7 days (last week)
          startDate = new Date(today);
          startDate.setDate(startDate.getDate() - 7);
          endDate = new Date(today);
          break;
        case "Monthly": {
          // If API didn't provide, fall back to current month
          startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;
        }
        default:
          startDate = new Date(today);
          endDate = new Date(today);
      }

      return { start: startDate, end: endDate };
    };

    // Format date for display (use UTC to avoid timezone shifts)
    const formatDateRange = () => {
      try {
        const { start, end } = calculateDateRange();

        if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) {
          return {
            full: "Loading date range...",
            short: "Loading...",
          };
        }

        // Full format for desktop: "Oct 01, 2025 → Oct 28, 2025"
        const fullFormat = `${start.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          timeZone: "UTC",
        })} → ${end.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          timeZone: "UTC",
        })}`;

        // Short format for mobile: "Oct 01 - Oct 28, 2025"
        const shortFormat = `${start.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          timeZone: "UTC",
        })} - ${end.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          timeZone: "UTC",
        })}`;

        return {
          full: fullFormat,
          short: shortFormat,
        };
      } catch (error) {
        console.error("Date formatting error:", error);
        return {
          full: "Date unavailable",
          short: "Date unavailable",
        };
      }
    };

    const formattedDates = formatDateRange();

    return (
      <div className="bg-white rounded-[25px] p-4 lg:p-6">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-4 gap-4">
          <div className="flex items-center gap-2">
            <h3 className="text-md font-semibold text-[#1A1C1E]">{title}</h3>
            {showInfo && (
              <div className="w-5 h-5 lg:w-6 lg:h-6 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-400 transition-colors flex-shrink-0">
                <img src="/important.png" className="w-4 h-4 lg:w-5 lg:h-5" />
              </div>
            )}
          </div>
          {month && (
            <div className="flex-1 flex justify-center order-2 lg:order-1">
              <div className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs text-center">
                <span className="hidden sm:inline">{formattedDates.full}</span>
                {/* <span className="sm:hidden">{formattedDates.short}</span> */}
              </div>
            </div>
          )}
          {month && (
            <div className="flex gap-2 order-3 lg:order-2">
              <button
                onClick={() => setActiveViewOption("Daily")}
                className={`px-2 lg:px-3 py-1 text-xs rounded font-medium transition-colors ${
                  activeViewOption === "Daily"
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-800"
                }`}
              >
                {t("dashboard.daily")}
              </button>
              <button
                onClick={() => setActiveViewOption("Weekly")}
                className={`px-2 lg:px-3 py-1 text-xs rounded font-medium transition-colors ${
                  activeViewOption === "Weekly"
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-800"
                }`}
              >
                {t("dashboard.weekly")}
              </button>
              <button
                onClick={() => setActiveViewOption("Monthly")}
                className={`px-2 lg:px-3 py-1 text-xs rounded font-medium transition-colors ${
                  activeViewOption === "Monthly"
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-800"
                }`}
              >
                {t("dashboard.monthly")}
              </button>
            </div>
          )}
        </div>
        {children}
      </div>
    );
  };

  // Generate sample data for April 2025
  const generateNetPaymentsData = () => {
    const data = [];
    const startDate = new Date(2025, 3, 1); // April 1, 2025
    const endDate = new Date(2025, 3, 30); // April 30, 2025

    for (
      let d = new Date(startDate);
      d <= endDate;
      d.setDate(d.getDate() + 1)
    ) {
      const day = d.getDate();
      const dayOfWeek = d.getDay();

      // Generate realistic data with upward trend
      const baseInflow = 2000 + day * 300 + Math.random() * 1000;
      const baseOutflow = 4000 + Math.random() * 100;

      // Weekend effect (lower inflow)
      const weekendMultiplier = dayOfWeek === 0 || dayOfWeek === 6 ? 0.7 : 1;

      data.push({
        date: d.toISOString().split("T")[0],
        day: day,
        inflow: Math.round(baseInflow * weekendMultiplier),
        outflow: Math.round(baseOutflow),
      });
    }

    return data;
  };

  const GrossVolumeChart = () => {
    const data = grossVolumeData;
    const [hoveredPoint, setHoveredPoint] = useState(null);
    const chartRef = React.useRef(null);
    const containerRef = React.useRef(null);

    // Calculate max value dynamically from data (use 'amount' field from API)
    const maxValue =
      data.length > 0
        ? Math.max(...data.map((item) => item.amount || 0)) * 1.1 // Add 10% padding
        : 100;

    const chartHeight = 100;
    const chartWidth = 1000; // Width in viewBox units

    // Helper function to get X position
    const getX = (index) => {
      if (data.length === 1) return chartWidth / 2;
      return (index / (data.length - 1)) * chartWidth;
    };

    // Helper function to get Y position
    const getY = (amount) => {
      if (maxValue === 0) return chartHeight;
      return chartHeight - (amount / maxValue) * chartHeight;
    };

    // Create SVG path for the line
    const createPath = () => {
      if (data.length === 0) return "";

      const points = data.map((item, index) => {
        const x = getX(index);
        const y = getY(item.amount || 0);
        return `${x},${y}`;
      });

      return `M ${points.join(" L ")}`;
    };

    // Create area fill path
    const createAreaPath = () => {
      if (data.length === 0) return "";

      const points = data.map((item, index) => {
        const x = getX(index);
        const y = getY(item.amount || 0);
        return `${x},${y}`;
      });

      const firstX = getX(0);
      const lastX = getX(data.length - 1);

      return `M ${firstX},${chartHeight} L ${points.join(" L ")} L ${lastX},${chartHeight} Z`;
    };

    // Format Y-axis labels
    const formatYAxisLabel = (value) => {
      if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
      if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
      return Math.round(value);
    };

    // Format date for display based on active view option
    const formatDateLabel = (dateStr, viewOption = activeViewOption) => {
      try {
        const date = new Date(dateStr);

        // Validate date
        if (isNaN(date.getTime())) {
          console.error("Invalid date:", dateStr);
          return "Invalid";
        }

        switch (viewOption) {
          case "Daily":
            // For daily view: "Oct 1", "Oct 2", etc.
            return date.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            });

          case "Weekly":
            // For weekly view: "Oct 1", "Oct 8", etc. (show start of week)
            return date.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            });

          case "Monthly":
            // For monthly view: "Jan", "Feb", "Mar", etc.
            return date.toLocaleDateString("en-US", {
              month: "short",
            });

          default:
            return date.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            });
        }
      } catch (error) {
        console.error("Date formatting error:", error, dateStr);
        return "Invalid";
      }
    };

    // Get X-axis date labels based on view option
    const getXAxisLabels = () => {
      if (data.length === 0) return [];

      const labels = [];

      switch (activeViewOption) {
        case "Daily": {
          // For daily: show every 5 days for better readability
          if (data.length <= 10) {
            // If less than 10 days, show all dates
            return data
              .filter((item) => item && item.level)
              .map((item, index) => ({
                text: formatDateLabel(item.level),
                position: index,
                index: index,
              }));
          } else {
            // Show start, then every ~5th day, then end
            const interval = Math.max(5, Math.floor(data.length / 6));

            for (let i = 0; i < data.length; i += interval) {
              if (data[i] && data[i].level) {
                labels.push({
                  text: formatDateLabel(data[i].level),
                  position: i,
                  index: i,
                });
              }
            }

            // Always add the last date if not already included
            const lastIndex = data.length - 1;
            if (
              labels.length === 0 ||
              labels[labels.length - 1].index !== lastIndex
            ) {
              if (data[lastIndex] && data[lastIndex].level) {
                labels.push({
                  text: formatDateLabel(data[lastIndex].level),
                  position: lastIndex,
                  index: lastIndex,
                });
              }
            }
          }
          break;
        }

        case "Weekly": {
          // For weekly: show every 7 days (weekly intervals)
          // Always show first date
          if (data[0] && data[0].level) {
            labels.push({
              text: formatDateLabel(data[0].level),
              position: 0,
              index: 0,
            });
          }

          // Show every 7th day for weekly intervals
          for (let i = 7; i < data.length - 1; i += 7) {
            if (data[i] && data[i].level) {
              labels.push({
                text: formatDateLabel(data[i].level),
                position: i,
                index: i,
              });
            }
          }

          // Always add the last date if not already included
          const lastIndex = data.length - 1;
          if (
            labels.length === 0 ||
            labels[labels.length - 1].index !== lastIndex
          ) {
            if (data[lastIndex] && data[lastIndex].level) {
              labels.push({
                text: formatDateLabel(data[lastIndex].level),
                position: lastIndex,
                index: lastIndex,
              });
            }
          }
          break;
        }

        case "Monthly": {
          // For monthly: show all months or quarterly points
          if (data.length <= 12) {
            // If 12 months or less, show all months
            return data
              .filter((item) => item && item.level)
              .map((item, index) => ({
                text: formatDateLabel(item.level),
                position: index,
                index: index,
              }));
          } else {
            // Show start, quarterly points, and end
            if (data[0] && data[0].level) {
              labels.push({
                text: formatDateLabel(data[0].level),
                position: 0,
                index: 0,
              });
            }

            const quarter = Math.floor(data.length / 4);
            for (let i = 1; i < 4; i++) {
              const idx = quarter * i;
              if (data[idx] && data[idx].level) {
                labels.push({
                  text: formatDateLabel(data[idx].level),
                  position: idx,
                  index: idx,
                });
              }
            }

            const lastIndex = data.length - 1;
            if (
              labels.length === 0 ||
              labels[labels.length - 1].index !== lastIndex
            ) {
              if (data[lastIndex] && data[lastIndex].level) {
                labels.push({
                  text: formatDateLabel(data[lastIndex].level),
                  position: lastIndex,
                  index: lastIndex,
                });
              }
            }
          }
          break;
        }

        default: {
          // Default: show start, middle, end
          if (data[0] && data[0].level) {
            labels.push({
              text: formatDateLabel(data[0].level),
              position: 0,
              index: 0,
            });
          }

          const midIndex = Math.floor(data.length / 2);
          if (data[midIndex] && data[midIndex].level) {
            labels.push({
              text: formatDateLabel(data[midIndex].level),
              position: midIndex,
              index: midIndex,
            });
          }

          const lastIndex = data.length - 1;
          if (data[lastIndex] && data[lastIndex].level) {
            labels.push({
              text: formatDateLabel(data[lastIndex].level),
              position: lastIndex,
              index: lastIndex,
            });
          }
        }
      }

      return labels;
    };

    const xAxisLabels = getXAxisLabels();

    // Format date for tooltip
    const formatTooltipDate = (dateStr) => {
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return "Invalid date";
        }
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      } catch (error) {
        return "Invalid date";
      }
    };

    // Handle mouse move over chart
    const handleMouseMove = (item, index) => {
      setHoveredPoint({ ...item, index });
    };

    // Handle mouse leave
    const handleMouseLeave = () => {
      setHoveredPoint(null);
    };

    if (grossVolumeLoading) {
      return (
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-sm text-gray-600">Loading chart data...</p>
          </div>
        </div>
      );
    }

    if (grossVolumeError) {
      return (
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-center">
            <div className="text-red-500 mb-4">
              <svg
                className="w-12 h-12 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
            <p className="text-sm text-gray-600 mb-4">{grossVolumeError}</p>
            <button
              onClick={fetchGrossVolumeData}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
            >
              Retry
            </button>
          </div>
        </div>
      );
    }

    if (data.length === 0) {
      return (
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-center">
            <p className="text-sm text-gray-600">No data available</p>
          </div>
        </div>
      );
    }

    // ApexCharts configuration built from backend data
    const categories = (data || []).map((item) => {
      const key = item.level || item.date || item.label;
      // For Weekly view, show backend text as-is
      if (activeViewOption === "Weekly") return key;
      return formatDateLabel(key);
    });
    const series = [
      {
        name: "Gross Volume",
        data: (data || []).map((item) => Number(item.amount || 0)),
      },
    ];

    const options = {
      chart: {
        type: "line",
        zoom: { enabled: false },
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      stroke: { curve: "straight", width: 3 },
      grid: {
        borderColor: "#E5E7EB",
        row: { colors: ["#F3F4F6", "transparent"], opacity: 0.5 },
        strokeDashArray: 4,
      },
      colors: ["#3B82F6"],
      xaxis: {
        categories,
        labels: { style: { colors: "#6B7280", fontSize: "12px" } },
        axisBorder: { color: "#E5E7EB" },
        axisTicks: { color: "#E5E7EB" },
      },
      yaxis: {
        labels: {
          formatter: (value) => {
            if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
            if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
            return Math.round(value);
          },
          style: { colors: "#6B7280", fontSize: "12px" },
        },
      },
      tooltip: {
        y: { formatter: (val) => `${val} USDT` },
      },
    };

    return (
      <div ref={containerRef} className="w-full h-full">
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={260}
        />
      </div>
    );
  };

  const NotificationsPopover = () => (
    <>
      {/* Mobile Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
        onClick={() => setShowNotifications(false)}
      />

      {/* Notifications Popover */}
      <div className="fixed inset-x-4 top-20 bottom-4 lg:absolute lg:right-0 lg:left-auto lg:top-auto lg:bottom-auto lg:mt-2 lg:w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50 notifications-popover flex flex-col max-h-[60vh]">
        <div className="p-4 border-b border-gray-200 flex-shrink-0">
          <div className="flex justify-between items-center">
            <h3 className="text-sm font-semibold text-gray-900">
              {t("header.notifications")}
            </h3>
            <div className="flex items-center gap-2">
              <button
                onClick={markAllAsRead}
                className="text-xs text-blue-600 hover:text-blue-800 transition-colors"
              >
                {t("header.markAllAsRead")}
              </button>
              <button
                onClick={() => setShowNotifications(false)}
                className="lg:hidden p-1 text-gray-400 hover:text-gray-600"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto min-h-0">
          {notificationsLoading ? (
            <div className="p-8 text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-sm text-gray-600">
                {t("header.loadingNotifications")}
              </p>
            </div>
          ) : notificationsError ? (
            <div className="p-8 text-center">
              <div className="text-red-500 mb-4">
                <svg
                  className="w-12 h-12 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
              <p className="text-sm text-gray-600 mb-4">{notificationsError}</p>
              <button
                onClick={() => fetchNotifications(1)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
              >
                {t("header.tryAgain")}
              </button>
            </div>
          ) : notifications.length === 0 ? (
            <div className="p-8 text-center">
              <div className="text-gray-400 mb-4">
                <FaRegBell className="w-12 h-12 mx-auto" />
              </div>
              <p className="text-sm text-gray-600">
                {t("header.noNotifications")}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {t("header.notificationsDescription")}
              </p>
            </div>
          ) : (
            notifications.map((notification) => (
              <div
                key={notification.id}
                className={`p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                  !notification.isRead ? "bg-blue-50" : ""
                }`}
              >
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 mt-1">
                    <FaRegBell
                      className={`w-4 h-4 ${
                        !notification.isRead ? "text-blue-500" : "text-gray-500"
                      }`}
                    />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <h4 className="text-sm font-semibold text-gray-900 mb-1">
                          {notification.title}
                        </h4>
                        <p className="text-xs text-gray-600 mb-2">
                          {notification.message}
                        </p>
                        <p className="text-xs text-gray-500">
                          {new Date(notification.createdAt).toLocaleString()}
                        </p>
                        {notification.amount && (
                          <p className="text-xs text-blue-600 font-medium mt-1">
                            {t("notifications.amount")}: {notification.amount}{" "}
                            USDT
                          </p>
                        )}
                      </div>

                      {!notification.isRead && (
                        <div className="flex-shrink-0 ml-2">
                          <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Pagination */}
        {notifications.length > 0 && notificationsPagination.totalPages > 1 && (
          <div className="p-4 border-t border-gray-200 flex-shrink-0">
            <div className="flex items-center justify-between">
              <div className="text-xs text-gray-500">
                {t("header.page")} {notificationsPagination.page}{" "}
                {t("header.of")} {notificationsPagination.totalPages}
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() =>
                    fetchNotifications(notificationsPagination.page - 1)
                  }
                  disabled={notificationsPagination.page <= 1}
                  className="px-3 py-1 text-xs text-gray-500 hover:text-gray-700 border border-gray-300 rounded hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {t("common.previous")}
                </button>
                <button
                  onClick={() =>
                    fetchNotifications(notificationsPagination.page + 1)
                  }
                  disabled={
                    notificationsPagination.page >=
                    notificationsPagination.totalPages
                  }
                  className="px-3 py-1 text-xs text-gray-500 hover:text-gray-700 border border-gray-300 rounded hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {t("common.next")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );

  // Reset Filters Function
  const handleResetFilters = () => {
    // Calculate dynamic default dates based on current date
    const today = new Date();
    const currentDate = today.toISOString().split("T")[0];

    // Calculate date 30 days ago from today
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const pastDate = thirtyDaysAgo.toISOString().split("T")[0];

    // Reset to default values
    setFromDate(pastDate);
    setToDate(currentDate);
    setActivePeriod("Monthly");
    setShowDatePicker(false);
    setShowPeriodDropdown(false);
    // Fetch dashboard stats with default period
    fetchDashboardStats();
  };

  const FilterSection = () => (
    <div className="flex justify-end items-center gap-4 mb-6">
      {/* All Filter Controls on Right Side */}
      <div className="flex flex-wrap items-center gap-3">
        {/* Payments/Refunds Tabs */}

        {/* Date Range Picker */}
        <div className="relative date-picker">
          <button
            onClick={() => setShowDatePicker(!showDatePicker)}
            className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors shadow-sm"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            {new Date(fromDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })}{" "}
            -{" "}
            {new Date(toDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })}
          </button>

          {/* {showDatePicker && (
            <div className="absolute right-0 lg:right-0 left-0 lg:left-auto mt-2 w-80 sm:w-96 lg:w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-4">
              <div className="space-y-4">
                <h3 className="text-sm font-semibold text-gray-900">
                  Select Date Range
                </h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      From Date
                    </label>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      To Date
                    </label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
                  <button
                    onClick={() => setShowDatePicker(false)}
                    className="w-full sm:w-auto px-3 py-2 text-xs text-gray-600 hover:text-gray-800 transition-colors border border-gray-300 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      if (fromDate && toDate) {
                        fetchDashboardStats(fromDate, toDate);
                      }
                      setShowDatePicker(false);
                    }}
                    disabled={!fromDate || !toDate}
                    className="w-full sm:w-auto px-3 py-2 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )} */}

          {showDatePicker && (
            <div
              className="
      absolute 
      mt-2 
      w-72 sm:w-80 lg:w-80 
      bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-4 
      left-1/2 -translate-x-1/3 sm:left-auto sm:translate-x-0 sm:right-0
    "
            >
              <div className="space-y-4">
                <h3 className="text-sm font-semibold text-gray-900">
                  Select Date Range
                </h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      From Date
                    </label>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      To Date
                    </label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
                  <button
                    onClick={() => setShowDatePicker(false)}
                    className="w-full sm:w-auto px-3 py-2 text-xs text-gray-600 hover:text-gray-800 transition-colors border border-gray-300 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      if (fromDate && toDate) {
                        fetchDashboardStats(fromDate, toDate);
                      }
                      setShowDatePicker(false);
                    }}
                    disabled={!fromDate || !toDate}
                    className="w-full sm:w-auto px-3 py-2 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <div className="w-px h-8 bg-gray-300"></div> */}

        {/* Period Dropdown */}
        <div className="relative period-dropdown">
          <button
            onClick={() => setShowPeriodDropdown(!showPeriodDropdown)}
            className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors shadow-sm"
          >
            {translatePeriod(activePeriod)}
            <svg
              className={`w-4 h-4 transition-transform ${
                showPeriodDropdown ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          {showPeriodDropdown && (
            <div className="absolute right-0 mt-2 w-32 bg-white border border-gray-200 rounded-2xl border border-slate-200/50 shadow-lg z-50">
              <button
                onClick={() => {
                  setActivePeriod("Daily");
                  setShowPeriodDropdown(false);
                }}
                className="w-full px-3 py-2 text-left text-sm text-gray-600 hover:bg-gray-50 rounded-t-2xl"
              >
                {t("dashboard.daily")}
              </button>
              <button
                onClick={() => {
                  setActivePeriod("Weekly");
                  setShowPeriodDropdown(false);
                }}
                className="w-full px-3 py-2 text-left text-sm text-gray-600 hover:bg-gray-50"
              >
                {t("dashboard.weekly")}
              </button>
              <button
                onClick={() => {
                  setActivePeriod("Monthly");
                  setShowPeriodDropdown(false);
                }}
                className="w-full px-3 py-2 text-left text-sm text-gray-600 hover:bg-gray-50"
              >
                {t("dashboard.monthly")}
              </button>
              <button
                onClick={() => {
                  setActivePeriod("Custom");
                  setShowPeriodDropdown(false);
                  setShowDatePicker(true);
                }}
                className="w-full px-3 py-2 text-left text-sm text-gray-600 hover:bg-gray-50 rounded-b-2xl"
              >
                {t("dashboard.custom") || "Custom"}
              </button>
            </div>
          )}
        </div>

        {/* Reset Filter Button */}
        <button
          onClick={handleResetFilters}
          className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors shadow-sm"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          {t("common.reset")}
        </button>

        {/* Filter Button */}
        {/* <button className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors shadow-sm">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            />
          </svg>
          Filter
        </button> */}

        {/* Export Button */}
        {/* <button className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors shadow-sm">
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
            />
          </svg>
          Export
        </button> */}
        {/* <button
          // onClick={openQRGenerator}
          style={{
            background: "linear-gradient(180deg, #3A5AD1 0%, #31ABFF 100%)",
            borderRadius: "10px"
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors w-full sm:w-auto flex items-center space-x-2 disabled:opacity-50"
        // disabled={apiCredentialsLoading}
        >
          <IoMdAdd className={`w-6 h-6`} />
          <span>Create Payment</span>
        </button> */}
        {/* <div className="flex bg-gray-100 rounded-lg p-1 border border-gray-300">
          <button
            onClick={() => setActiveTab("PAYMENTS")}
            className={`px-4 py-1 text-sm font-semibold transition-all duration-200 ${
              activeTab === "PAYMENTS"
                ? "bg-[#348BED1A] text-blue-600 rounded-[6px] shadow-sm"
                : "text-gray-600 hover:text-gray-500 bg-transparent"
            }`}
          >
            PAYMENTS
          </button>
          <button
            onClick={() => setActiveTab("REFUNDS")}
            className={`px-4 py-1 text-sm font-semibold transition-all duration-200 ${
              activeTab === "REFUNDS"
                ? "bg-[#348BED1A] text-blue-600 rounded-[6px] shadow-sm"
                : "text-gray-600 hover:text-gray-500 bg-transparent"
            }`}
          >
            WITHDRAWAL
          </button>
        </div> */}
      </div>
    </div>
  );

  const DashboardContent = () => (
    <div className="space-y-4 lg:space-y-6">
      {/* Filter Section */}
      <FilterSection />

      {/* Top Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
        <StatCard
          title={t("dashboard.deposit")}
          value={
            statsLoading ? (
              <div className="animate-pulse h-8 w-32 bg-gray-200 rounded"></div>
            ) : statsError ? (
              t("common.error")
            ) : (
              `$${(dashboardStats?.totalDeposit || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            )
          }
          subtitle={
            statsLoading ? (
              <div className="animate-pulse h-4 w-24 bg-gray-200 rounded"></div>
            ) : (
              t("dashboard.totalDeposit")
            )
          }
          showDropdown={false}
          showView={true}
        />
        <div className="space-y-4">
          <StatCard
            title={t("dashboard.payouts")}
            value={
              statsLoading ? (
                <div className="animate-pulse h-8 w-32 bg-gray-200 rounded"></div>
              ) : statsError ? (
                t("common.error")
              ) : (
                `$${(dashboardStats?.totalPayout || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
              )
            }
            subtitle={
              statsLoading ? (
                <div className="animate-pulse h-4 w-24 bg-gray-200 rounded"></div>
              ) : dashboardStats?.lastPayoutDate ? (
                `${t("dashboard.deposited")} ${new Date(dashboardStats.lastPayoutDate).toLocaleDateString("en-US", { month: "short", day: "numeric" })}`
              ) : (
                t("dashboard.totalPayouts")
              )
            }
            showView={true}
          />
        </div>
      </div>

      {/* Gross Volume Chart */}
      <ChartCard
        title={t("dashboard.grossVolume")}
        month={true}
        showInfo={true}
        dateRange={
          grossVolumePeriod
            ? {
                start: grossVolumePeriod.startDate,
                end: grossVolumePeriod.endDate,
              }
            : null
        }
      >
        <div className="mb-6">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-4 gap-4">
            {/* Left side - Gross Volume */}
            <div className="text-left lg:text-left">
              <div className="text-xl lg:text-1xl font-medium text-gray-900 mb-1">
                {grossVolumeLoading ? (
                  <div className="animate-pulse h-6 w-32 bg-gray-200 rounded"></div>
                ) : (
                  `${grossVolumeTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDT`
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Line Chart */}
        <div className="h-55 lg:h-70 overflow-hidden">
          <GrossVolumeChart />
        </div>
      </ChartCard>

      {/* Middle Row */}
      <RecentDashboard dashboardStats={dashboardStats} />

      {/* Bottom Row */}

      {/* Net Payments Chart and Balance Dashboard Side by Side */}
      <div className="grid grid-cols-1 lg:grid-cols-1 gap-4 lg:gap-6">
        {/* <ChartCard title="Net payments" showInfo={true}>
          <div className="mb-1">
            <div className="flex justify-between items-start ">
              <div className="text-sm text-gray-500">
                {(() => {
                  // Calculate date range based on activeViewOption
                  const today = new Date();
                  let startDate, endDate;

                  switch (activeViewOption) {
                    case 'Daily':
                      // Today only
                      startDate = new Date(today);
                      endDate = new Date(today);
                      break;
                    case 'Weekly':
                      // Today + next 7 days
                      startDate = new Date(today);
                      endDate = new Date(today);
                      endDate.setDate(endDate.getDate() + 7);
                      break;
                    case 'Monthly':
                      // Current month
                      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
                      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                      break;
                    default:
                      startDate = new Date(today);
                      endDate = new Date(today);
                  }

                  // If API data is available, use it instead
                  if (grossVolumeData.length > 0) {
                    try {
                      startDate = new Date(grossVolumeData[0].level || grossVolumeData[0].date || grossVolumeData[0].label);
                      endDate = new Date(grossVolumeData[grossVolumeData.length - 1].level || grossVolumeData[grossVolumeData.length - 1].date || grossVolumeData[grossVolumeData.length - 1].label);
                    } catch (error) {
                      // Keep calculated dates if parsing fails
                    }
                  }

                  const formatDate = (date) => {
                    try {
                      return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
                    } catch {
                      return 'Invalid date';
                    }
                  };

                  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
                })()}
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => setActiveViewOption("Daily")}
                  className={`px-3 py-1 text-xs rounded font-medium transition-colors ${activeViewOption === "Daily"
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-800"
                    }`}
                >
                  Daily
                </button>
                <button
                  onClick={() => setActiveViewOption("Weekly")}
                  className={`px-3 py-1 text-xs rounded font-medium transition-colors ${activeViewOption === "Weekly"
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-800"
                    }`}
                >
                  Weekly
                </button>
                <button
                  onClick={() => setActiveViewOption("Monthly")}
                  className={`px-3 py-1 text-xs rounded font-medium transition-colors ${activeViewOption === "Monthly"
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-800"
                    }`}
                >
                  Monthly
                </button>
              </div>
            </div>

            {/* Metrics */}
        {/* <div className="flex items-center gap-8 mb-6"> */}
        {/* <div className="text-center">
                <div className="text-2xl font-bold text-gray-900">~ 98.4%</div>
                <div className="text-xs text-gray-500 mt-1">Rate</div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-blue-500 rounded-sm"></div>
                <div className="text-center">
                  <div className="text-lg font-semibold text-gray-900">3,927</div>
                  <div className="text-xs text-gray-500">Inflow</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-gray-400 rounded-sm"></div>
                <div className="text-center">
                  <div className="text-lg font-semibold text-gray-900">34</div>
                  <div className="text-xs text-gray-500">Out flow</div>
                </div>
              </div>
            </div>
          </div> */}

        {/* Bar Chart */}
        {/* <div className="h-54">
            <NetPaymentsChart />
          </div>
        </ChartCard> */}
        <div className="w-full">
          <BalanceDashboard />
        </div>
      </div>
    </div>
  );

  const BalancesContent = () => (
    <div className="space-y-6">
      <Dashboard />
    </div>
  );

  const DocsContent = () => (
    <div className="space-y-6">
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <h2 className="text-xl font-bold text-gray-900 mb-4">
          {t("comming.comingSoonTitle")}
        </h2>
        <div className="text-gray-500">
          {t("comming.comingSoonDescription")}
        </div>
      </div>
    </div>
  );

  // Check if we're on the settings page
  const isSettingsPage = location.pathname === "/New-Dashboard/settings";

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Overlay */}
      {sidebarOpen && !isSettingsPage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Fixed Sidebar - Hidden on Settings Page */}
      {!isSettingsPage && (
        <div
          className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-sm border-r border-gray-200 transform transition-transform duration-300 ease-in-out lg:translate-x-0 flex flex-col h-full ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          {/* Logo */}
          <div className="relative p-3 border-b border-gray-200">
            <div className="flex items-center gap-3 ">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center ">
                <img src="/LOGOM.png" alt="3Pay Logo" id="im" />
              </div>
              <span className="text-xl font-extrabold text-gray-900">3PAY</span>
            </div>

            {/* User Profile Section */}
            {/* <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white border border-blue-200 rounded-lg flex items-center justify-center">
              {profileData?.logo ? (
                <img
                  src={profileData.logo}
                  alt={profileData.name || "Profile"}
                  className="w-8 h-8 rounded-lg object-cover"
                />
              ) : (
                <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                  <span className="text-sm font-medium text-blue-600">
                    {profileData?.name ? profileData.name[0].toUpperCase() : "U"}
                  </span>
                </div>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-900 truncate">
                {profileData?.name || "User Name"}
              </div>
              <div className="text-xs text-gray-600 truncate">
                {profileData?.companyName || "Company Name"}
              </div>
            </div>
          </div> */}

            {/* Close button for mobile */}
            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Navigation */}
          <div className="flex flex-col flex-1 min-h-0">
            <div className="flex-1 p-4 overflow-y-auto">
              <h4 className="text-xs font-medium text-gray-400 tracking-wider mb-3">
                {t("sidebar.general")}
              </h4>
              <div className="space-y-1">
                {sidebarItems.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      navigate(item.path);
                      setSidebarOpen(false);
                    }}
                    className={`w-full flex items-center gap-3 px-3 py-2 rounded-[10px] text-left transition-colors ${
                      item.active
                        ? "bg-[#F6F7F8] text-[#348BED]"
                        : "text-gray-600 hover:bg-gray-50"
                    }`}
                  >
                    <div
                      className={`w-8 h-8 flex items-center justify-center rounded-[6px] transition-colors ${
                        item.active ? "bg-[#E3F2FD]" : "bg-[#f0f1f3]"
                      }`}
                    >
                      {renderIcon(item.icon, item.active)}
                    </div>

                    <span className="text-sm font-medium">{item.name}</span>
                  </button>
                ))}
              </div>

              {/* Services Section */}
              {servicesItems.length > 0 && (
              <div className="mt-6">
                <h4 className="text-xs font-medium text-gray-400 tracking-wider  mb-3">
                  {t("sidebar.services")}
                </h4>
                <div className="space-y-1">
                  {servicesItems.map((item) => (
                    <div key={item.name}>
                      <button
                        onClick={() => {
                          if (item.hasDropdown) {
                            setWalletsDropdownOpen(!walletsDropdownOpen);
                          } else {
                            navigate(item.path);
                            setSidebarOpen(false);
                          }
                        }}
                        className={`w-full flex items-center justify-between gap-3 px-3 py-2 rounded-[6px] text-left transition-colors ${
                          item.active
                            ? "bg-[#F6F7F8] text-[#348BED]"
                            : "text-gray-600 hover:bg-gray-50"
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          <div
                            className={`w-8 h-8 flex items-center justify-center rounded-[10px] transition-colors ${
                              item.active ? "bg-[#E3F2FD]" : "bg-[#f0f1f3]"
                            }`}
                          >
                            {renderIcon(item.icon, item.active)}
                          </div>
                          <span className="text-sm font-medium">
                            {item.name}
                          </span>
                        </div>
                        {item.hasDropdown && (
                          <HiChevronDown
                            className={`w-4 h-4 transition-transform ${walletsDropdownOpen ? "rotate-180" : ""}`}
                          />
                        )}
                      </button>

                      {/* Dropdown items for Wallets */}
                      {item.hasDropdown && walletsDropdownOpen && (
                        <div className="space-y-1">
                          {item.dropdownItems.map((dropdownItem) => (
                            <button
                              key={dropdownItem.name}
                              onClick={() => {
                                navigate(dropdownItem.path);
                                setSidebarOpen(false);
                              }}
                              className={`w-full text-left pl-14 mt-1 pr-3 py-2 rounded-[6px] transition-colors ${
                                location.pathname === dropdownItem.path
                                  ? "bg-[#F6F7F8] text-[#348BED]"
                                  : "text-gray-600 hover:bg-gray-50"
                              }`}
                            >
                              <span className="text-sm font-medium">
                                {dropdownItem.name}
                              </span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              )}
            </div>

            {/* Developers Section - Fixed at bottom */}
            {/* Show only if user has manage_api permission */}
            {developersItems.length > 0 && (
              <div className="mt-auto p-4 ">
                <div className="space-y-1">
                  {developersItems?.map((item) => (
                    <button
                      key={item.name}
                      onClick={() => {
                        navigate(item.path);
                        setSidebarOpen(false);
                      }}
                      className={`w-full flex items-center gap-3 px-3 py-2 rounded-[10px] text-left transition-colors ${
                        item.active
                          ? "bg-[#F6F7F8] text-[#348BED]"
                          : "text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      <div
                        className={`w-8 h-8 flex items-center justify-center rounded-[6px] transition-colors ${
                          item.active ? "bg-[#E3F2FD]" : "bg-[#f0f1f3]"
                        }`}
                      >
                        {renderIcon(item.icon, item.active)}
                      </div>
                      <span className="text-sm font-medium">{item.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Header for lanaguge and Setting */}
      {!isSettingsPage && (
        <div
          className={`fixed top-0 right-0 left-0 lg:left-64 z-30 px-4 lg:px-6 py-2 transition-all duration-300 ease-in-out ${
            isScrolled
              ? "bg-#f6f7f8/95 backdrop-blur-sm shadow-md border-b border-gray-200/20"
              : "bg-#f6f7f8"
          }`}
        >
          <div className="flex justify-between items-center h-12">
            <div className="flex items-center gap-4">
              {/* Hamburger menu button for mobile */}
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden p-2 text-gray-600 hover:text-gray-900"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>{" "}
            </div>
            <div className="flex items-center gap-4 ">
              <div className="relative">
                <button
                  onClick={() => setShowNotifications(!showNotifications)}
                  className="p-2 text-gray-600 hover:text-gray-900 transition-colors"
                >
                  <FaRegBell className="w-6 h-6" />
                </button>
                {showNotifications && <NotificationsPopover />}
              </div>

              {canAccessPage("/New-Dashboard/settings") && (
                <button
                  onClick={() => navigate("/New-Dashboard/settings")}
                  className="p-2 text-gray-600 hover:text-gray-900 transition-colors"
                >
                  <IoSettingsOutline className="w-6 h-6 text-gray-600" />
                </button>
              )}

              {/* Language Dropdown */}
              <div className="relative language-dropdown">
                <button
                  onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                  className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg hover:bg-gray-50"
                >
                  <IoLanguage className="w-5 h-5" />
                  <span className="text-sm font-medium hidden sm:inline">
                    {currentLanguage}
                  </span>
                  <HiChevronDown
                    className={`w-4 h-4 transition-transform ${showLanguageDropdown ? "rotate-180" : ""}`}
                  />
                </button>
                {showLanguageDropdown && (
                  <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                    <button
                      onClick={() => {
                        changeLanguage("English");
                        setShowLanguageDropdown(false);
                      }}
                      className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors rounded-t-lg ${
                        currentLanguage === "English"
                          ? "bg-blue-50 text-blue-600 font-medium"
                          : "text-gray-700"
                      }`}
                    >
                      {t("language.english")}
                    </button>
                    <button
                      onClick={() => {
                        changeLanguage("Arabic");
                        setShowLanguageDropdown(false);
                      }}
                      className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors ${
                        currentLanguage === "Arabic"
                          ? "bg-blue-50 text-blue-600 font-medium"
                          : "text-gray-700"
                      }`}
                    >
                      {t("language.arabic")}
                    </button>
                    <button
                      onClick={() => {
                        changeLanguage("Spanish");
                        setShowLanguageDropdown(false);
                      }}
                      className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors ${
                        currentLanguage === "Spanish"
                          ? "bg-blue-50 text-blue-600 font-medium"
                          : "text-gray-700"
                      }`}
                    >
                      {t("language.spanish")}
                    </button>
                    <button
                      onClick={() => {
                        changeLanguage("French");
                        setShowLanguageDropdown(false);
                      }}
                      className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors rounded-b-lg ${
                        currentLanguage === "French"
                          ? "bg-blue-50 text-blue-600 font-medium"
                          : "text-gray-700"
                      }`}
                    >
                      {t("language.french")}
                    </button>
                  </div>
                )}
              </div>

              {/* Divider */}
              <div className="h-6 w-px bg-gray-300"></div>
              {/* {profile Section person} */}
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-10 bg-white rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => setShowLogoutModal(true)}
                >
                  {profileLoading ? (
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                  ) : profileData?.logo ? (
                    <img
                      src={profileData.logo}
                      alt={profileData.name || "Profile"}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                      <span className="text-sm font-medium text-gray-600">
                        {profileData?.name
                          ? profileData.name[0].toUpperCase()
                          : "U"}
                      </span>
                    </div>
                  )}
                </div>
                <div className="text-right hidden sm:block">
                  {profileLoading ? (
                    <div className="animate-pulse">
                      <div className="h-4 bg-gray-200 rounded w-20 mb-1"></div>
                      <div className="h-3 bg-gray-200 rounded w-16"></div>
                    </div>
                  ) : profileError ? (
                    <></>
                  ) : (
                    // <div className="text-sm text-red-600">
                    //   Error loading profile
                    // </div>
                    <>
                      <div className="text-sm font-medium text-gray-900">
                        {profileData?.name || "User"}
                      </div>
                      <div className="text-xs text-gray-500">
                        {profileData?.role || "Business"}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Scrollable Main Content */}
      <div
        className={`min-h-screen bg-gray-100 ${
          isSettingsPage ? "p-4 lg:p-6" : "pt-20 lg:pt-20 pb-10 lg:ml-64"
        }`}
      >
        <div className={isSettingsPage ? "" : "p-4 lg:p-6"}>
          <Routes>
            <Route
              index
              element={
                <AuthGuard>
                  <DashboardContent />
                </AuthGuard>
              }
            />
            <Route
              path="transactions"
              element={
                <AuthGuard>
                  <NewTransaction />
                </AuthGuard>
              }
            />
            <Route
              path="balances"
              element={
                <AuthGuard>
                  <BalancesContent />
                </AuthGuard>
              }
            />
            <Route
              path="wallet"
              element={
                <AuthGuard>
                  <WalletServices />
                </AuthGuard>
              }
            />
            <Route
              path="wallet/walletbyid/:userId"
              element={
                <AuthGuard>
                  <WalletuserId />
                </AuthGuard>
              }
            />
            <Route
              path="role-management"
              element={
                <AuthGuard>
                  <RoleManagementPage />
                </AuthGuard>
              }
            />
            <Route
              path="widthdrawal"
              element={
                <AuthGuard>
                  <WidthdrawalNew />
                </AuthGuard>
              }
            />
            <Route
              path="settings"
              element={
                <AuthGuard>
                  <SettingsPage />
                </AuthGuard>
              }
            />
            <Route
              path="payments"
              element={
                <AuthGuard>
                  <NewPaymentLink />
                </AuthGuard>
              }
            />
            <Route
              path="api-docs"
              element={
                <AuthGuard>
                  <SettingsPage />
                </AuthGuard>
              }
            />
            <Route
              path="/security/2fa"
              element={
                <AuthGuard>
                  <TwoFactorAuthPage />
                </AuthGuard>
              }
            />
            <Route
              path="docs"
              element={
                <AuthGuard>
                  <DocsContent />
                </AuthGuard>
              }
            />
            {/* <Route path="referrals" element={
              <AuthGuard>
                <ReferralPage />
              </AuthGuard>
            } /> */}
          </Routes>
        </div>
      </div>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                <svg
                  className="w-6 h-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                {t("logout.title")}
              </h2>
              <button
                onClick={() => setShowLogoutModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="mb-6">
              <p className="text-gray-600">{t("logout.message")}</p>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="flex-1 bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition-colors"
              >
                {t("logout.cancel")}
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors"
              >
                {t("logout.confirm")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 2FA Enforcement Modal */}
      <TwoFAEnforcementModal
        isOpen={show2FAModal && twoFAEnabled === false}
        onClose={() => {}} // Don't allow closing - user must enable 2FA
      />
    </div>
  );
};

export default NewDashboard;
